import { render, staticRenderFns } from "./LoginSdkFb.vue?vue&type=template&id=9ec80fc4&scoped=true&"
import script from "./LoginSdkFb.vue?vue&type=script&lang=js&"
export * from "./LoginSdkFb.vue?vue&type=script&lang=js&"
import style0 from "./LoginSdkFb.vue?vue&type=style&index=0&id=9ec80fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec80fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ec80fc4')) {
      api.createRecord('9ec80fc4', component.options)
    } else {
      api.reload('9ec80fc4', component.options)
    }
    module.hot.accept("./LoginSdkFb.vue?vue&type=template&id=9ec80fc4&scoped=true&", function () {
      api.rerender('9ec80fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/LoginSdkFb.vue"
export default component.exports